// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"BarChartDataTooltip_tooltip__1ZqIc","colorBlock":"BarChartDataTooltip_colorBlock__2zcf8"};